import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Card } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import AuthService from "../../services/auth.service";
import { Info, Sms } from "../../stories/ActionAlert.stories";
import UserService from "../../services/user.service";
import ToastBlockContainer from "../../common/ToastBlockContainer";
import { Secondary } from "../../stories/Button.stories";
import Modal from "react-bootstrap/Modal";
import ReactCodeInput from "react-verification-code-input";

const AuthHeader = (props) => {
  const splitUrl = window.location.href.split("/");
  let history = useHistory();
  let items = JSON.parse(localStorage.getItem("UserDetails"));
  const [showToast, setShowToast] = useState(false);
  const [successToast, setSuccessToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [formCodeValues, setFormCodeValues] = useState("");
  const [formCodeErrors, setFormCodeErrors] = useState({});
  const [smsErr, setSmsErr] = useState({});
  const [loadingCode, setLoadingCode] = useState(false);
  const [FamilyDataList, setFamilyDataList] = useState();
  const [showVerificationModel, setShowVerificationModel] = useState(false);
  const [smsmodal, setSmsModal] = useState(false);

  const handleShowVerificationModelClose = () => {
    setShowVerificationModel(false);
    setFormCodeErrors({});
    setSmsErr({});
    setLoadingCode(false);
  };
  var UserDetails = JSON.parse(localStorage.getItem("UserDetails"));

  // Navigating during render does not halt the render, so this used to fall
  // through into the dereferences below. The actual bail-out is the
  // `if (!items) return null` further down, once all hooks have run.
  useEffect(() => {
    if (!items) {
      history.push("/");
    }
  }, [items]);

  const handleVerificationChange = (e) => {
    let codeValue = e;
    setFormCodeValues(codeValue);
  };

  // email code
  const handleResendEmailCode = (userUUID) => {
    setLoadingCode(true);
    UserService.resendUserEmailCode(userUUID).then(
      (response) => {
        setSuccessToast(true);
        setShowToast(true);
        setToastMessage("Verification code sent successfully");
        setFormCodeValues("");
        setLoadingCode(false);
        setTimeout(() => {
          setShowVerificationModel(true);
        }, 2000);
      },
      (error) => {}
    );
  };

  // sms code
  const handleSMS = (userUUID) => {
    // setLoadingCode(true);
    UserService.resendUserSMSCode(userUUID, {}).then(
      (response) => {
        if (response.status === 200) {
          setSuccessToast(true);
          setShowToast(true);
          setToastMessage("Verification code sent via SMS successfully");
          setFormCodeValues("");
          setTimeout(() => {
            setSmsModal(true);
          }, 3000);
        } else {
          setSuccessToast(false);
          setShowToast(true);
          setToastMessage(
            "Contact number not found ! Please update in your profile section"
          );
        }
      },
      (error) => {}
    );
  };

  const handleVerificationSubmit = (e) => {
    e.preventDefault();
    setFormCodeErrors(validateEmailCode(formCodeValues));
  };

  const validateEmailCode = (values) => {
    setLoadingCode(false);
    const c_errors = {};
    if (values.length !== 6) {
      c_errors.msg = "Please enter valid verification code";
      c_errors.code = "Yes";
      setLoadingCode(false);
      setSuccessToast(false);
      setShowToast(true);
      setToastMessage(c_errors.msg);
    } else {
      let data = {
        code: formCodeValues,
      };
      setLoadingCode(true);
      // api call
      AuthService.verifyUserEmail(data, items.uuid).then(
        (res) => {
          if (res.status === 400) {
            setFormCodeValues("");
            setLoadingCode(false);
            setShowVerificationModel(true);
            setSuccessToast(false);
            setShowToast(true);
            setToastMessage(res.data.error);
          } else {
            setLoadingCode(false);
            setShowVerificationModel(false);
            items["isEmailVerified"] = true;
            localStorage.setItem("UserDetails", JSON.stringify(items));
            setSuccessToast(true);
            setShowToast(true);
            setToastMessage("Email verified successfully");
          }
        },
        (error) => {
          const errors = {};

          errors.msg = error.response;
          if (errors.msg) {
            setFormCodeErrors(errors);
          }
          setLoadingCode(false);
        }
      );
    }
    return c_errors;
  };

  const handleVerificationSubmitSMS = (e) => {
    e.preventDefault();
    setSmsErr(validateSmsCode(formCodeValues));
  };

  const validateSmsCode = (values) => {
    const c_errors = {};
    setLoadingCode(true);
    if (values.length !== 6) {
      c_errors.msg = "Please enter valid verification code";
      c_errors.code = "Yes";
      setLoadingCode(false);
      setSuccessToast(false);
      setShowToast(true);
      setToastMessage(c_errors.msg);
    } else {
      let data = {
        code: formCodeValues,
      };

      // api call
      UserService.smscheck(items.uuid, data).then(
        (response) => {
          if (response && response.status === 200) {
            setSuccessToast(true);
            setShowToast(true);
            setToastMessage("Contact number verified");
            const newObj = {
              ...items,
              isContactVerified: true,
            };
            localStorage.setItem("UserDetails", JSON.stringify(newObj));
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          } else {
            setLoadingCode(false);
            setSuccessToast(false);
            setShowToast(true);
            setToastMessage("Invalid verifiaction code !");
          }
        },
        (error) => {
          if (error.response.status === 400) {
            setLoadingCode(false);
          }
        }
      );
    }
    return c_errors;
  };

  useEffect(() => {
    if (splitUrl[3] === "profile" && UserDetails) {
      UserService.userProfile(UserDetails.uuid).then(
        (response) => {
          if (response && response.userData) {
            setFamilyDataList(response.userData.createdAt);
          }
        },
        (error) => {}
      );
    }
  }, []);

  // date check for email, phone verification
  var myData = JSON.parse(localStorage.getItem("UserDetails"));

  // All hooks have run by this point, so it is safe to bail out. Everything
  // below dereferences `items`.
  if (myData === null || items === null) {
    return null;
  }
  var CreationDate = FamilyDataList;
  var CD = new Date(Date.parse(CreationDate) + 6 * 24 * 60 * 60 * 1000);
  var dd1 = String(CD.getDate()).padStart(2, "0");
  var mm1 = String(CD.getMonth() + 1).padStart(2, "0"); //January is 0!
  var yyyy1 = CD.getFullYear();
  CD = dd1 + "/" + mm1 + "/" + yyyy1;
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  var yyyy = today.getFullYear();
  today = dd + "/" + mm + "/" + yyyy;
  const date = new Date(Date.parse(CreationDate));
  date.setDate(date.getDate() + 6);

  if (
    splitUrl[3] !== "confirmation" &&
    splitUrl[3] !== "onboardUser" &&
    splitUrl[3] !== "newcard_billing_details"
  ) {
    return (
      <div className="header">
        <Container fluid>
          <ToastBlockContainer
            successToast={successToast}
            showToast={showToast}
            setShowToast={setShowToast}
            toastMessage={toastMessage}
          />
          <Row className="justify-content-center gy-0">
            <Col md="24" lg="20" xl="18" xxl="16">
              {splitUrl[3] === "profile" ? (
                items.isEmailVerified && items.isContactVerified ? (
                  ""
                ) : (
                  <Card
                    className={`action-alert-card info-alert mb-7 gap-3`}
                    style={{ background: "transparent", boxShadow: "none" }}
                  >
                    {items.isEmailVerified === false &&
                      items.isActive === true && (
                        <Info
                          variant="info"
                          message="Your email is not verified yet. Please verify your email to continue using our services"
                          onButtonClick={() =>
                            handleResendEmailCode(items.uuid)
                          }
                        />
                      )}
                    {items.isContactVerified === false &&
                      items.isActive === true && (
                        <Sms
                          variant="sms"
                          message="Your contact number is not verified yet. Please verify your number to continue using our services"
                          onButtonClick={() => handleSMS(items.uuid)}
                        />
                      )}
                  </Card>
                )
              ) : (
                ""
              )}
            </Col>

            <Modal
              show={showVerificationModel}
              onHide={handleShowVerificationModelClose}
              className="verification_modal"
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  <h3>Verify Email</h3>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p className="mb-4">
                  We have sent a 6 digit verification code to your email{" "}
                  <strong>{items.email}</strong>.
                </p>
                <Form
                  className="verification-form"
                  onSubmit={handleVerificationSubmit} // email
                >
                  <div
                    className={`mb-2 fs-18 fw-semibold ${
                      formCodeErrors.code ? "text-danger" : ""
                    }`}
                  >
                    Verification Code
                  </div>
                  <ReactCodeInput
                    value={formCodeValues}
                    name="code"
                    fields={6}
                    onChange={handleVerificationChange}
                    className={`react-input-class ${
                      formCodeErrors.code ? "inputErr" : ""
                    }`}
                  />
                  <input type="hidden" name="regUser" value={items.uuid} />
                  <div className="mt-5 mb-5 d-flex align-items-center justify-content-between">
                    <button
                      onClick={() => handleResendEmailCode(items.uuid)}
                      className="btn btn-white"
                      type="button"
                    >
                      {" "}
                      Resend the Code
                    </button>
                    <Secondary
                      children="Verify email"
                      size="mediumbtn"
                      variant="secondary"
                      type=""
                      className="btn btn-primary"
                      font_Weight="600"
                      isLoading={loadingCode ? "true" : "false"}
                      isDisabled={loadingCode ? "true" : "false"}
                    />
                  </div>
                </Form>
              </Modal.Body>
            </Modal>
          </Row>

          <Modal
            show={smsmodal}
            onHide={() => {
              setSmsModal(false);
              setFormCodeErrors({});
              setSmsErr({});
              setLoadingCode(false);
            }}
            className="choose_plan_modal"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <h3 className="mb-0">Verify Contact Number</h3>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p className="mb-4">
                We have sent a 6 digit verification code to verify the contact
                number mentioned against your Elderly Life account .
              </p>
              <Form
                className="verification-form"
                onSubmit={handleVerificationSubmitSMS} // sms
              >
                <div
                  className={`mb-2 fs-18 fw-semibold ${
                    smsErr.code ? "text-danger" : ""
                  }`}
                >
                  Verification Code
                </div>
                <ReactCodeInput
                  value={formCodeValues}
                  name="code"
                  fields={6}
                  onChange={handleVerificationChange}
                  className={`react-input-class ${
                    smsErr.code ? "inputErr" : ""
                  }`}
                />
                <input type="hidden" name="regUser" value={items.uuid} />

                <div className="mt-5 mb-5 d-flex align-items-center justify-content-between">
                  <button
                    onClick={() => handleSMS(items.uuid)}
                    className="btn btn-white"
                    type="button"
                  >
                    {" "}
                    Resend the Code
                  </button>
                  <Secondary
                    children="Verify contact number"
                    size="mediumbtn"
                    variant="primary"
                    type=""
                    font_Weight="600"
                    className="btn btn-primary"
                    isLoading={loadingCode ? "true" : "false"}
                    isDisabled={loadingCode ? "true" : "false"}
                  />
                </div>
              </Form>
            </Modal.Body>
          </Modal>
        </Container>
      </div>
    );
  } else {
    return "";
  }
};
export default AuthHeader;
